import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

const ROUTE_LABEL_KEYS: Record<string, string> = {
  '/console': 'nav.dashboard',
  '/console/api-keys': 'nav.apiKeys',
  '/console/available-models': 'nav.availableModels',
  '/console/log': 'nav.log',
  '/console/playground': 'nav.playground',
  '/console/chat': 'nav.chat',
  '/console/midjourney': 'nav.midjourney',
  '/console/task': 'nav.task',
  '/console/personal': 'nav.personal',
  '/console/topup': 'nav.topup',
  '/console/channel': 'nav.channel',
  '/console/user': 'nav.user',
  '/console/models': 'nav.models',
  '/console/deployment': 'nav.deployment',
  '/console/redemption': 'nav.redemption',
  '/console/topup-orders': 'nav.topupOrders',
  '/console/subscription': 'nav.subscription',
  '/console/setting': 'nav.setting',
}

export function useConsoleBreadcrumb() {
  const { t, i18n } = useTranslation()
  const location = useLocation()

  return useMemo(() => {
    const exact = ROUTE_LABEL_KEYS[location.pathname]
    if (exact) return t(exact)
    const sorted = Object.keys(ROUTE_LABEL_KEYS).sort((a, b) => b.length - a.length)
    for (const key of sorted) {
      if (location.pathname.startsWith(key)) return t(ROUTE_LABEL_KEYS[key])
    }
    return t('layout.console')
  }, [location.pathname, t, i18n.language])
}
